import React, { useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import 'scss/components/page-components/Layout/QuicknavSidebar.scss';
import { useTranslate2 } from 'js/components/helpers/Translate.js';
import AppContext from  'js/Contexts/App.js'; 

const QuicknavSidebar = ({ currentAccount }) => {
  const appContext = useContext(AppContext);
  const { layoutTranslations } = appContext;
  const translate = useTranslate2(layoutTranslations?.translations || {});
  const [hasDeveloperAccess, setHasDeveloperAccess] = useState(false);

  useEffect(() => {
    const checkDeveloperAccess = async () => {
      if (currentAccount?.id) {
        const hasRightSubscription = await appContext.AccountSubscriptionService.hasAnyAccountSubscription(currentAccount.id, ['godmode','developer-account']);
          if (hasRightSubscription) {
            setHasDeveloperAccess(true);
            return;
          }
          else{
            setHasDeveloperAccess(false);
          }
        }
    };
    checkDeveloperAccess();
  }, [currentAccount?.id]);

  return (
    <div className="L_QuicknavSidebar">
      <div className="sidebarContainer">
            <Link to={ currentAccount ? "/a/ac/" + currentAccount.id : "/a/me/dashboard"} className="logo"><img src="/img/logos/ordercollab-favicon_white_48x48.png" /><span className="order">Order</span><span className="collab">Collab</span></Link>

        <div className='quickNavItem'>
          <span className='quickNavTitle'>
            <Link to="/a/me/settings">
              <img src="/icon/layout/user-white.svg" className="quickNavIcon" />
              <h3>{translate('Sidebar.MyAccount', 'My Account')}</h3>
            </Link>
          </span>
          <ul>
            <li>
              <Link to="/a/me/security" className="navItem"> <img src="/icon/layout/security-icon-white.svg" className="navIcon" /> {translate('Sidebar.SecuritySettings', 'Security Settings')} </Link>
            </li>
            <li>
              <Link to="/a/me/accounts" className="navItem"> <img src="/icon/layout/three-people-icon-white.svg" className="navIcon" /> {translate('Sidebar.Organizations', 'Organizations')} </Link>
            </li>
            <li>
              <Link to="a/me/display-language" className="navItem"><img src="/icon/layout/language-icon-white.svg" className="navIcon" /> {translate('Sidebar.DisplayLanguage', 'Display Language')} </Link>
            </li>
          </ul>
        </div>
        {currentAccount?.id && (
          <div className='quickNavItem'>
            <span className='quickNavTitle'>
              <Link to={`/a/ac/${currentAccount.id}/managers`}>
                <img src="/icon/layout/three-people-icon-white.svg" className="quickNavIcon" />
                <h3>Organization</h3>
              </Link>
            </span>
            <ul>
              {hasDeveloperAccess && (
                <li>
                  <Link to={`/a/ac/${currentAccount.id}/developer-apps`} className="navItem"> <img src="/icon/layout/code-icon-white.svg" className="navIcon" /> {translate('Sidebar.DeveloperApps', 'Developer Apps')} </Link>
                </li>
              )}
              <li>
                <Link to={`/a/ac/${currentAccount.id}/managers`} className="navItem"> <img src="/icon/layout/two-people-icon-white.svg" className="navIcon" /> {translate('Sidebar.ManageUsers', 'Manage Users')} </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default QuicknavSidebar
